import { VStack } from "@chakra-ui/react";
import { TreatmentPieChart } from "./TreatmentPieChart";
import { CraAttributePieChart } from "./CraAttributePieChart";
import { CraScorePieChart } from "./CraScorePieChart";
import { CraAttributes } from "@keita/lanepatrol-sdk";
import {
  CraColoring,
  CraColoringType,
} from "../../../../map/models/CraColoring";

export const CraPieChart = ({ craColoring }: { craColoring: CraColoring }) => {
  const renderContent = () => {
    switch (craColoring.type) {
      case CraColoringType.Treatment:
        return <TreatmentPieChart treatmentType={craColoring.treatmentType} />;
      case CraColoringType.Attribute:
        return (
          <CraAttributePieChart
            attributeDefinition={
              CraAttributes.getByName(craColoring.attributeName)!
            }
          />
        );
      case CraColoringType.Score:
        return <CraScorePieChart crashType={craColoring.scoreKey} />;
    }
  };

  return <VStack fontSize="sm">{renderContent()}</VStack>;
};
